import React, {Component} from "react";
import Group1 from "../../../images/Group 1.png";

class Tiers extends Component{

    constructor(props){
        super(props);
        this.state = {
            showConnect : false,
        }
    }

    render(){
        return(
            <div className="breadcrumb-area">
                <div>
                    <h1>Tiers</h1>
                </div>
                <div style={{margin:"4rem 0"}}>
                        <div>
                            <h2> <i className="fi fi-rr-apps beside_icon"></i> <span className="sec-txt">APY </span> 10%</h2>
                        </div>
                        <p>Max staking amount per wallet: 100,000 Arata. </p>
                        <p>Withdrawal timeout 7 days.</p>
                    </div>
                
                <div className="rounds-flex tier-flex">
                    <div className="">
                        <h4 className="sec-txt">Your Balance</h4>
                        <div className="rounds-flex">
                            <p className="bold-text" style={{width:"8rem"}}>0 Arata</p>
                            <button style={{width:"10rem", padding:"4% 5%"}}>Buy Arata</button>
                        </div>
                    </div>
                    {/* <button>
                        <i className="fas fa-link"></i>
                                Connect Wallet
                    </button> */}
                    
                </div>
                <div className="tier-inline-div-card br-10">
                    <h3>Your staked amount: Arata</h3>
                    <div className="rounds-flex tier-child-flex centralized-v">
                        <div className="tert-bg padded br-10">
                            <h4>Tier - 1 </h4>
                            <p>20 000 Arata</p>
                            <div>
                                <button onClick={() => this.setState({showConnect : !this.state.showConnect})}>Connect Wallet</button>
                            </div>
                        </div>
                        <span className="link-line"></span>
                        <div className="tert-bg padded br-10">
                            <h4>Tier - 2 </h4>
                            <p>30 000 Arata</p>
                            <div>
                                <button onClick={() => this.setState({showConnect : !this.state.showConnect})}>Connect Wallet</button>
                            </div>
                        </div>
                        <span className="link-line"></span>
                        <div className="tert-bg padded br-10">
                            <h4>Tier - 3 </h4>
                            <p>40 000 Arata</p>
                            <div>
                                <button onClick={() => this.setState({showConnect : !this.state.showConnect})}>Connect Wallet</button>
                            </div>
                        </div>
                        <span className="link-line"></span>
                        <div className="tert-bg padded br-10">
                            <h4>Tier - 4 </h4>
                            <p>50 000 Arata</p>
                            <div>
                                <button onClick={() => this.setState({showConnect : !this.state.showConnect})}>Connect Wallet</button>
                            </div>
                        </div>
                    </div>
                    {/* <div className="connected-line">
                        <div className="connected-line-child">
                            <div className="ellipse-div">
                                <div className="ellipse">
                                    <div className="ellipse-child"></div>
                                </div>
                                <div className="ellipse">
                                    <div className="ellipse-child"></div>
                                </div>
                                <div className="ellipse">
                                    <div className="ellipse-child"></div>
                                </div>
                                <div className="ellipse">
                                    <div className="ellipse-child"></div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    {/* <div className="rounds-flex tier-child-flex tier-button-flex">
                        
                        <div>
                            <button onClick={() => this.setState({showConnect : !this.state.showConnect})}>Connect Wallet</button>
                        </div>
                        <div>
                            <button onClick={() => this.setState({showConnect : !this.state.showConnect})}>Connect Wallet</button>
                        </div>
                        <div>
                            <button onClick={() => this.setState({showConnect : !this.state.showConnect})}>Connect Wallet</button>
                        </div>
                    </div> */}
                </div>

                
                {
                    this.state.showConnect ?
                    
                    <div className="modal-widget">
                        <div className="modal-child">
                            <i className="fi fi-rr-cross" onClick={() => this.setState({showConnect: !this.state.showConnect})}></i>
                            <h3>Connect Wallet</h3>
                            <button>MetaMask</button>
                        </div>
                    </div>

                    : null
                }
            </div>
        );
    }
}

export default Tiers;